<template>
  <div class="achievementindex">
    <div class="header">
      <el-button size="medium" type="primary" @click="achievementadd()">创建试卷模板</el-button>
      <el-button size="medium" type="primary" @click="achievementTypeindex()">维护学科题型</el-button>
        <el-select size="medium" class="filter-item" filterable v-model="schoolTypeId" placeholder="请选择学段" @change="getCurrBySchoolTypes()">
          <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in schoolTypelist"></el-option>
        </el-select>
        <el-select size="medium" class="filter-item" filterable v-model="currId" placeholder="请选择学科" @change="publicTempalteLists()">
          <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in currlist"></el-option>
        </el-select>
    </div>
    <div class="body" :style="`height: ${windowHeight - 180}px;`">
        <div class="title" v-if="templateSmallList.length">按小题</div>
        <div class="boxSmalllist">
             <div class="box" :key="indexs" v-for="(items,indexs) in templateSmallList">
                    <div class="boxtop" :title="items.templateName">{{items.templateName}}</div>
                    <i class="el-icon-edit" @click="achievementeidt(items.id)"></i>
                    <i class="el-icon-delete" @click="deleteTempaltes(items.id)"></i>
                    <i class="el-icon-document"></i>
                    <div class="ul">                        
                       <div class="li" :key="index" v-for="(item,index) in items.questionList">
                           <span class="name">{{index+1}}.{{item.queTypeName}}</span>
                           <span class="numname">共{{item.queCount}}题  总计{{item.totalScore}}分</span>
                        </div>
                    </div>
             </div>
            
         </div>
        <div class="title"  v-if="templateBigList.length">按大题</div>
        <div class="boxSmalllist">
             <div class="box" :key="indexs" v-for="(items,indexs) in templateBigList">
                    <div class="boxtop" :title="items.templateName">{{items.templateName}}</div>
                    <i class="el-icon-edit" @click="achievementeidt(items.id)"></i>
                    <i class="el-icon-delete" @click="deleteTempaltes(items.id)"></i>
                    <i class="el-icon-document"></i>
                    <div class="ul">                        
                       <div class="li" :key="index" v-for="(item,index) in items.questionList">
                           <span class="name">{{index+1}}.{{item.queTypeName}}</span>
                           <span class="numname">{{item.totalScore}}分</span>
                        </div>
                    </div>
             </div>
         </div>
         <default-page Mes="暂无模板" v-if="isnum==0"></default-page>
    </div>
  </div>
</template>
<script>
import windowResize from "@/mixins/windowResize";
import {
  publicTempalteList,
  deleteTempalte,
  getCurrBySchoolType
} from "@/api/achievement";
import DefaultPage from "@/components/DefaultPage";
export default {
  name: "suiteManageIndex",
  data() {
    return {
      templateSmallList: [],
      templateBigList: [],
      currlist: [],
      schoolTypelist: [
        // { name: "幼儿园", id: 1 },
        { name: "小学", id: 2 },
        { name: "初中", id: 3 },
        { name: "高中", id: 4 },
        // { name: "六年制", id: 6 },
        // { name: "九年制", id: 9 },
        // { name: "十二年制", id: 12 },
        // { name: "特殊学校", id: 10 }
      ],
      schoolTypeId: 2,
      currId: "",
      isnum:1
    };
  },
  mixins: [windowResize],
  components: {DefaultPage},
  created() {
    this.getCurrBySchoolTypes();
  },
  methods: {
   //编辑
   achievementeidt(id){
     this.$router.push({path: 'achievementeidt',query: {id:id}})
   },
   //新增
   achievementadd(){
     this.$router.push({path: 'achievementadd'})
   },
   //题型
   achievementTypeindex(){
     this.$router.push({path: 'achievementTypeindex'})
   },
    getCurrBySchoolTypes() {
      this.currlist=[];
      getCurrBySchoolType(this.schoolTypeId)
        .then(res => res.data)
        .then(data => {
          for(let i=0;i<data.length;i++){
            if(data[i].examType==1){
               this.currlist.push(data[i])
            }
          }
          if (this.currlist.length > 0) {
            this.currId = this.currlist[0].id;
          } else {
            this.currId = "";
          }
          this.publicTempalteLists();
        });
    },
    publicTempalteLists() {
      if (!this.currId) {
        this.templateSmallList = [];
        this.templateBigList = [];
        this.isnum=0;
        return;
      }
      publicTempalteList(this.schoolTypeId, this.currId)
        .then(res => res.data)
        .then(data => {
          let mydata = data.data;
          this.templateSmallList = mydata.templateSmallList;
          this.templateBigList = mydata.templateBigList;
          this.isnum=this.templateBigList.length+this.templateSmallList.length;
        });
    },
     //删除模板
    deleteTempaltes(id){
         this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                   deleteTempalte(id).then(res => {
                      if (res.data.code === 200) {
                            this.$message({
                                            type: 'success',
                                            message: '删除成功!'
                                        });
                            this.publicTempalteLists()
                        }                    
                    }).catch(err=>{
                    });
                }).catch(() => { });
    },
  }
};
</script>

<style lang="scss" scoped>
.achievementindex {
  padding: 12px;
  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .title {
    height: 20px;
    line-height: 20px;
    margin-top: 15px;
    margin-left: 15px;
    padding-left: 8px;
    border-left: 4px solid #409eff;
    font-weight: bold;
  }
  .boxSmalllist {
    overflow: hidden;
    .box {
      width:320px;
      height: 255px;
      margin: 10px 1.5%;
      float: left;
      padding: 5px 10px;
      position: relative;
      box-sizing: border-box;
      box-shadow: 5px 5px 15px #ddd;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      position: relative;
      cursor: pointer;
      .boxtop {
            width: 70%;
            display: block;
            margin: 0 auto;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            text-align: center;
            font-size: 18px
          }
      .el-icon-delete{
          position: absolute;
          top:5px;
          right: 8px;
          font-size: 18px;
          color: #909399;
      }
      .el-icon-edit{
          position: absolute;
          top:5px;
          right: 32px;
          font-size: 18px;
          color: #909399;
      }
      .el-icon-document{
          position: absolute;
          top:5px;
          left: 10px;
          font-size: 18px;
          color:#ee9611;
      }
      .el-icon-delete:hover{
          color:#F56C6C;
      }
      .el-icon-edit:hover{
          color:#409EFF;
      }
      .ul {
        height: 215px;
        overflow: auto;
        font-size: 14px;
        .li {
          padding: 10px 0;         
          .numname {
            float: right;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/achievement/achievementindex.vue